import { useEffect } from "react";
import { useAppStore } from "src/hooks/useAppStore.ts";

export const useDebugTranslations = () => {
  const appStore = useAppStore();
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const isMac = navigator.platform.toUpperCase().includes("MAC");

      // macOS uses metaKey (⌘), others use ctrlKey
      const isShortcutPressed =
        (isMac && event.metaKey) || (!isMac && event.ctrlKey);

      if (isShortcutPressed && event.key.toLowerCase() === "u") {
        event.preventDefault();
        const enabled = !appStore.debugTranslations;
        appStore.setDebugTranslations(enabled);
        /* eslint-disable no-console */
        console.log(
          enabled
            ? "Debug translations enabled"
            : "Debug translations disabled",
        );
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [appStore]);
};
